import { PROJECT_SCOPE } from '../../data/sessions';
import { C, Badge, Card } from './shared';

export default function ScopeTab() {
  const sc = PROJECT_SCOPE;
  const totalMo = sc.membershipReplacement.reduce((s, m) => s + m.costPerMonth, 0).toFixed(2);
  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div style={{ background: C.card, borderRadius: 10, padding: 20,
        borderTop: '4px solid ' + C.green, border: '1px solid ' + C.green + '44' }}>
        <div style={{ color: C.green, fontWeight: 800, fontSize: 16, marginBottom: 8 }}>
          MarketPulze — {sc.product.identity}
        </div>
        <div style={{ padding: '8px 12px', background: C.purple + '22', borderRadius: 8,
          border: '1px solid ' + C.purple + '44', marginBottom: 8 }}>
          <span style={{ color: C.purple, fontWeight: 700, fontSize: 12 }}>END GOAL: </span>
          <span style={{ color: C.text, fontSize: 12 }}>{sc.product.endGoal}</span>
        </div>
        <div style={{ padding: '8px 12px', background: C.warning + '11', borderRadius: 8,
          border: '1px solid ' + C.warning + '33' }}>
          <span style={{ color: C.warning, fontWeight: 700, fontSize: 12 }}>MONETISATION: </span>
          <span style={{ color: C.muted, fontSize: 12 }}>{sc.product.monetisationTimeline}</span>
        </div>
      </div>

      <div style={{ background: C.purple + '11', borderRadius: 10, padding: '12px 16px',
        border: '1px solid ' + C.purple + '33' }}>
        <span style={{ color: C.purple, fontWeight: 700, fontSize: 12 }}>TWO EQUAL MASTERS: </span>
        <span style={{ color: C.subtle, fontSize: 12 }}>{sc.fourProducts.twoEqualMasters}</span>
      </div>

      <Card title="Four-Product Hierarchy" accent={C.green}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 10 }}>
          {sc.fourProducts.products.map(p => (
            <div key={p.n} style={{ background: C.surface, borderRadius: 8, padding: 14,
              border: '1px solid ' + (p.n === 1 ? C.green : p.n === 2 ? C.purple : C.info) + '44' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                flexWrap: 'wrap', gap: 6, marginBottom: 6 }}>
                <span style={{ color: p.n === 1 ? C.green : p.n === 2 ? C.purple : C.info,
                  fontWeight: 800, fontSize: 12 }}>Product {p.n} — {p.name}</span>
                <Badge color={p.n === 1 ? C.green : p.n === 2 ? C.purple : C.info}>{p.status}</Badge>
              </div>
              <div style={{ color: C.muted, fontSize: 10, marginBottom: 6 }}>Access: {p.access}</div>
              <div style={{ color: C.subtle, fontSize: 11, lineHeight: 1.6 }}>{p.summary}</div>
            </div>
          ))}
        </div>
      </Card>

      <Card title="D3 — 7-Layer LLM Engine" accent={C.purple}>
        {sc.fourProducts.sevenLayerEngine.map(l => (
          <div key={l.l} style={{ display: 'flex', gap: 12, padding: '8px 0',
            borderBottom: '1px solid ' + C.border + '22', flexWrap: 'wrap', alignItems: 'flex-start' }}>
            <Badge color={C.purple}>{l.l}</Badge>
            <span style={{ color: C.text, fontSize: 12, fontWeight: 700, flex: '0 1 160px' }}>{l.name}</span>
            <span style={{ color: C.info, fontSize: 11, fontFamily: 'monospace', flex: '0 1 150px' }}>{l.model}</span>
            <span style={{ color: C.muted, fontSize: 11, flex: '2 1 240px' }}>{l.detail}</span>
          </div>
        ))}
        <div style={{ marginTop: 14, marginBottom: 8, color: C.purple, fontWeight: 700, fontSize: 11,
          textTransform: 'uppercase', letterSpacing: '0.06em' }}>D3 6-Inflection Signal Framework</div>
        <div style={{ color: C.muted, fontSize: 11, marginBottom: 8 }}>{sc.fourProducts.inflectionsNote}</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 6 }}>
          {sc.fourProducts.sixInflections.map((inf, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, padding: '6px 10px',
              background: C.surface, borderRadius: 6 }}>
              <span style={{ color: C.purple, fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{i + 1}.</span>
              <span style={{ color: C.subtle, fontSize: 11 }}>{inf}</span>
            </div>
          ))}
        </div>
      </Card>

      <Card title="D3 Owner Portal — Visibility & Privacy" accent={C.danger}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 16 }}>
          <div>
            <div style={{ color: C.green, fontWeight: 700, fontSize: 11, marginBottom: 8,
              textTransform: 'uppercase', letterSpacing: '0.06em' }}>Owner Portal Features</div>
            {sc.fourProducts.ownerPortalFeatures.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, padding: '4px 0' }}>
                <span style={{ color: C.green, fontSize: 11, flexShrink: 0 }}>✓</span>
                <span style={{ color: C.subtle, fontSize: 11 }}>{f}</span>
              </div>
            ))}
          </div>
          <div>
            <div style={{ color: C.danger, fontWeight: 700, fontSize: 11, marginBottom: 8,
              textTransform: 'uppercase', letterSpacing: '0.06em' }}>What Stays Private Forever</div>
            {sc.fourProducts.whatStaysPrivate.map((f, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, padding: '4px 0' }}>
                <span style={{ color: C.danger, fontSize: 11, flexShrink: 0 }}>✗</span>
                <span style={{ color: C.subtle, fontSize: 11 }}>{f}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ marginTop: 14, padding: '10px 12px', background: C.surface, borderRadius: 8 }}>
          <div style={{ color: C.warning, fontWeight: 700, fontSize: 11, marginBottom: 4 }}>
            Broker Adapter Architecture (Rule R33, permanent)
          </div>
          <div style={{ color: C.subtle, fontSize: 11, marginBottom: 6 }}>{sc.fourProducts.brokerAdapter.rule}</div>
          {sc.fourProducts.brokerAdapter.adapters.map((a, i) => (
            <div key={i} style={{ color: C.muted, fontSize: 11, paddingLeft: 8 }}>• {a}</div>
          ))}
          <div style={{ color: C.muted, fontSize: 10, marginTop: 6, fontStyle: 'italic' }}>
            {sc.fourProducts.brokerAdapter.note}
          </div>
        </div>
      </Card>

      <Card title="Privacy Boundaries — What Each Product Accesses" accent={C.info}>
        <div style={{ overflowX: 'auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8,
            padding: '6px 0', borderBottom: '1px solid ' + C.border, minWidth: 480 }}>
            <span style={{ color: C.muted, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>Capability</span>
            <span style={{ color: C.green, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>Members (P1)</span>
            <span style={{ color: C.info, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>Inner Circle (P3)</span>
            <span style={{ color: C.purple, fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>Owner Only (P2)</span>
          </div>
          {sc.fourProducts.privacyBoundaries.map((row, i) => (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 8,
              padding: '7px 0', borderBottom: '1px solid ' + C.border + '22', minWidth: 480 }}>
              <span style={{ color: C.text, fontSize: 11 }}>{row.capability}</span>
              <span style={{ color: C.subtle, fontSize: 11 }}>{row.p1}</span>
              <span style={{ color: C.subtle, fontSize: 11 }}>{row.p3}</span>
              <span style={{ color: C.subtle, fontSize: 11 }}>{row.p2}</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 10, color: C.muted, fontSize: 10, fontStyle: 'italic' }}>
          {sc.fourProducts.sourceNote}
        </div>
      </Card>

      <Card title="3-Stage Master Plan" accent={C.info}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
          {sc.threeStages.map(s => (
            <div key={s.stage} style={{ background: C.surface, borderRadius: 8, padding: 14,
              border: '1px solid ' + (s.stage===1?C.green:s.stage===2?C.warning:C.purple) + '44' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ color: s.stage===1?C.green:s.stage===2?C.warning:C.purple,
                  fontWeight: 800, fontSize: 12 }}>Stage {s.stage} — {s.name}</span>
                <Badge color={s.stage===1?C.green:s.stage===2?C.warning:C.purple}>{s.status}</Badge>
              </div>
              <div style={{ color: C.subtle, fontSize: 11, lineHeight: 1.6 }}>{s.goal}</div>
              <div style={{ color: C.muted, fontSize: 10, marginTop: 6 }}>Trigger: {s.trigger}</div>
            </div>
          ))}
        </div>
      </Card>

      <Card title="User Tiers" accent={C.warning}>
        {sc.userTiers.map(t => (
          <div key={t.tier} style={{ display: 'grid', gridTemplateColumns: '110px 1fr 1fr',
            gap: 12, padding: '9px 0', borderBottom: '1px solid ' + C.border + '33' }}>
            <span style={{ color: t.tier==='Super Admin'?C.purple:t.tier==='Guest'?C.info:t.tier==='Admin'?C.warning:C.green,
              fontWeight: 700, fontSize: 12 }}>{t.tier}</span>
            <span style={{ color: C.subtle, fontSize: 11, lineHeight: 1.5 }}>{t.access}</span>
            <span style={{ color: C.muted, fontSize: 10, fontFamily: 'monospace' }}>{t.authCode}</span>
          </div>
        ))}
      </Card>

      <div style={{ background: C.card, borderRadius: 10, padding: 20,
        borderTop: '4px solid ' + C.purple, border: '1px solid ' + C.purple + '55' }}>
        <div style={{ color: C.purple, fontWeight: 800, fontSize: 14, marginBottom: 8 }}>
          IBKR Automated Trading — Keep In Memory Every Session
        </div>
        <div style={{ color: C.danger, fontSize: 12, fontWeight: 600, marginBottom: 10 }}>
          {sc.ibkrMemory.rule}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
          <div style={{ background: C.green + '11', borderRadius: 8, padding: 10, border: '1px solid ' + C.green + '33' }}>
            <div style={{ color: C.green, fontWeight: 700, fontSize: 11, marginBottom: 4 }}>DISPLAY SIGNAL</div>
            <div style={{ color: C.text, fontSize: 14, fontWeight: 800 }}>{sc.ibkrMemory.signalDisplay}</div>
          </div>
          <div style={{ background: C.purple + '11', borderRadius: 8, padding: 10, border: '1px solid ' + C.purple + '33' }}>
            <div style={{ color: C.purple, fontWeight: 700, fontSize: 11, marginBottom: 4 }}>ENGINE SIGNAL</div>
            <div style={{ color: C.text, fontSize: 14, fontWeight: 800 }}>{sc.ibkrMemory.signalEngine}</div>
          </div>
        </div>
        <div style={{ color: C.muted, fontSize: 11, marginBottom: 6 }}>
          <span style={{ color: C.warning, fontWeight: 700 }}>Current blocker: </span>
          {sc.ibkrMemory.currentBlocker}
        </div>
        <div style={{ color: C.muted, fontSize: 10, lineHeight: 1.6 }}>
          <span style={{ color: C.info, fontWeight: 700 }}>Chain: </span>
          {sc.ibkrMemory.dependencyChain.join(' > ')}
        </div>
      </div>

      <Card title={'Membership Replacement — $' + totalMo + '/mo to free ($4,811/yr)'} accent={C.danger}>
        <div style={{ color: C.muted, fontSize: 11, marginBottom: 10 }}>
          Benzinga Pro ✅ CANCELLED May 2026. All others: active pending replacement validation. Cancel each only when live replacement confirmed.
        </div>
        {sc.membershipReplacement.map(m => (
          <div key={m.platform} style={{ display: 'grid', gridTemplateColumns: '160px 80px 1fr 70px',
            gap: 8, padding: '7px 0', borderBottom: '1px solid ' + C.border + '22', alignItems: 'center' }}>
            <span style={{ color: C.text, fontSize: 12, fontWeight: 600 }}>{m.platform}</span>
            <span style={{ color: C.danger, fontSize: 12, fontWeight: 700 }}>${m.costPerMonth}/mo</span>
            <span style={{ color: C.muted, fontSize: 11 }}>{m.cancelAfter}</span>
            <Badge color={C.info}>{m.session}</Badge>
          </div>
        ))}
      </Card>

      <Card title="Guest Hook Design — Maintain In Every New Feature" accent={C.info}>
        {sc.guestHookRules.map((h, i) => (
          <div key={i} style={{ display: 'flex', gap: 8, padding: '6px 0',
            borderBottom: '1px solid ' + C.border + '22' }}>
            <span style={{ color: C.info, fontSize: 11, flexShrink: 0, marginTop: 2 }}>&#9656;</span>
            <span style={{ color: C.subtle, fontSize: 12 }}>{h}</span>
          </div>
        ))}
      </Card>

      <Card title="Vendor Philosophy — Free Until Revenue" accent={C.warning}>
        <div style={{ marginBottom: 10, padding: '8px 12px', background: C.warning + '11',
          borderRadius: 8, border: '1px solid ' + C.warning + '33' }}>
          <span style={{ color: C.warning, fontSize: 12 }}>{sc.vendorPhilosophy.vendorAgnosticRule}</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8, marginBottom: 10 }}>
          {sc.vendorPhilosophy.currentStack.map(v => (
            <div key={v.name} style={{ background: C.surface, borderRadius: 8, padding: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ color: C.text, fontWeight: 700, fontSize: 12 }}>{v.name}</span>
                <Badge color={v.status==='PRIMARY'||v.status==='ACTIVE'?C.green:C.info}>{v.status}</Badge>
              </div>
              <div style={{ color: C.warning, fontSize: 10 }}>{v.cost}</div>
              <div style={{ color: C.muted, fontSize: 10, marginTop: 4 }}>{v.note}</div>
            </div>
          ))}
        </div>
        <div style={{ padding: '8px 12px', background: C.card, borderRadius: 8, border: '1px solid ' + C.border }}>
          <span style={{ color: C.warning, fontWeight: 700, fontSize: 11 }}>FMP: </span>
          <span style={{ color: C.muted, fontSize: 11 }}>{sc.vendorPhilosophy.fmpStatus.reason} Revisit: {sc.vendorPhilosophy.fmpStatus.revisitWhen}</span>
        </div>
      </Card>

      <Card title="Future Portal Segregation — Phase D Only (No Code Now)" accent={C.purple}>
        <div style={{ color: C.muted, fontSize: 11, marginBottom: 10 }}>{sc.portalSegregation.why}</div>
        {sc.portalSegregation.future.map(p => (
          <div key={p.subdomain} style={{ display: 'grid', gridTemplateColumns: '260px 1fr 90px',
            gap: 10, padding: '8px 0', borderBottom: '1px solid ' + C.border + '22' }}>
            <span style={{ color: C.info, fontFamily: 'monospace', fontSize: 12 }}>{p.subdomain}</span>
            <span style={{ color: C.subtle, fontSize: 11 }}>{p.purpose}</span>
            <Badge color={p.phase.includes('live') ? C.green : C.purple}>
              {p.phase.includes('live') ? 'LIVE' : 'PHASE D'}
            </Badge>
          </div>
        ))}
        <div style={{ marginTop: 10, padding: '8px 12px', background: C.warning + '11',
          borderRadius: 8, border: '1px solid ' + C.warning + '33' }}>
          <span style={{ color: C.warning, fontWeight: 700, fontSize: 11 }}>Trigger: </span>
          <span style={{ color: C.muted, fontSize: 11 }}>{sc.portalSegregation.trigger}</span>
        </div>
      </Card>
    </div>
  );
}

